"use client";
import { j as f } from "./jsx-runtime-CJ-St4mQ.mjs";
import { N as ve, u as x, f as he, a as Ne, g as Ee, h as we, i as Me, j as Re, k as Pe } from "./NavigationMenu.style-Dq96CLFG.mjs";
import xe from "./ArrowSvg.js";
import * as e from "react";
import { c as Ce, k as ye } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import { u as Oe } from "./useControlled-B2rPEZCb.mjs";
import { u as te } from "./useEventCallback-CjuAhyNz.mjs";
import { o as ue } from "./owner-DpSCkBia.mjs";
import { u as j, e as Se, D as Ve } from "./useRenderElement-B8V3_e8R.mjs";
import { u as Ie, a as ne } from "./useOpenChangeComplete-CXAVaIGe.mjs";
import { g as be, N as oe, a as ie } from "./NavigationMenuPositionerCssVars-DZFKlrfE.mjs";
import { a as je, b as De, d as Te } from "./FloatingTree-vWe5pGqE.mjs";
import { e as Fe, c as ce } from "./element-DE7VsBMX.mjs";
import { F as Ae } from "./FloatingPortal-B6chGyBH.mjs";
import * as He from "react-dom";
import { g as Le } from "./floating-ui.utils-CqK2Pznf.mjs";
import { u as _e } from "./useTimeout-BRUciAq6.mjs";
import { u as ke } from "./useAnchorPositioning-DZydZPwe.mjs";
import { p as Y } from "./popupStateMapping-Cl0RMVD6.mjs";
import { i as X, e as ze, d as Be, F as se, a as Ue, g as We } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { t as Xe } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { u as Ye } from "./useBaseUiId-a-UPSsPQ.mjs";
import { u as Ge } from "./DirectionContext-D4ZBZehF.mjs";
import { u as $e } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as qe } from "./useId-CFOlRH4L.mjs";
import { i as Je } from "./inertValue-CseOXFGF.mjs";
function re(i, o) {
  const {
    width: c,
    height: a
  } = be(i);
  i.style.setProperty(o === "popup" ? oe.popupWidth : ie.positionerWidth, `${c}px`), i.style.setProperty(o === "popup" ? oe.popupHeight : ie.positionerHeight, `${a}px`);
}
const le = /* @__PURE__ */ e.forwardRef(function(o, c) {
  const {
    defaultValue: a = null,
    value: g,
    onValueChange: n,
    actionsRef: v,
    delay: p = 50,
    closeDelay: l = 50,
    orientation: u = "horizontal",
    onOpenChangeComplete: t
  } = o, s = je() != null, [r, w] = Oe({
    controlled: g,
    default: a,
    name: "NavigationMenu",
    state: "value"
  }), d = r != null, m = e.useRef(void 0), h = e.useRef(null), [N, P] = e.useState(null), [M, V] = e.useState(null), [D, _] = e.useState(null), [I, k] = e.useState(null), [T, y] = e.useState(null), [b, O] = e.useState(void 0), [F, A] = e.useState(!1), E = e.useRef(null), H = e.useRef(null), z = e.useRef(null), B = e.useRef(null), R = e.useRef(null), C = e.useRef(null), {
    mounted: U,
    setMounted: q,
    transitionStatus: J
  } = Ie(d);
  e.useEffect(() => {
    A(!1);
  }, [r]);
  const K = te((S, W, ee) => {
    S || (m.current = ee, y(null), O(void 0), N && M && (re(M, "popup"), re(N, "positioner"))), S !== r && (n == null || n(S, W, ee)), w(S);
  }), Q = te(() => {
    const S = ue(h.current), W = Fe(S);
    m.current !== "trigger-hover" && Ce(E.current) && ce(M, W) && M && (E.current.focus({
      preventScroll: !0
    }), E.current = void 0), q(!1), t == null || t(!1), y(null), O(void 0), H.current = null, m.current = void 0;
  });
  ne({
    enabled: !v,
    open: d,
    ref: {
      current: M
    },
    onComplete() {
      d || Q();
    }
  }), ne({
    enabled: !v,
    open: d,
    ref: {
      current: I
    },
    onComplete() {
      d || Q();
    }
  });
  const ge = e.useMemo(() => ({
    open: d,
    value: r,
    setValue: K,
    mounted: U,
    transitionStatus: J,
    positionerElement: N,
    setPositionerElement: P,
    popupElement: M,
    setPopupElement: V,
    viewportElement: D,
    setViewportElement: _,
    viewportTargetElement: I,
    setViewportTargetElement: k,
    activationDirection: T,
    setActivationDirection: y,
    floatingRootContext: b,
    setFloatingRootContext: O,
    currentContentRef: H,
    nested: s,
    rootRef: h,
    beforeInsideRef: z,
    afterInsideRef: B,
    beforeOutsideRef: R,
    afterOutsideRef: C,
    prevTriggerElementRef: E,
    delay: p,
    closeDelay: l,
    orientation: u,
    viewportInert: F,
    setViewportInert: A
  }), [d, r, K, U, J, N, M, D, I, T, b, s, p, l, u, F]), Z = /* @__PURE__ */ f.jsx(ve.Provider, {
    value: ge,
    children: /* @__PURE__ */ f.jsx(Ke, {
      componentProps: o,
      forwardedRef: c,
      children: o.children
    })
  });
  return s ? Z : /* @__PURE__ */ f.jsx(De, {
    children: Z
  });
});
process.env.NODE_ENV !== "production" && (le.displayName = "NavigationMenuRoot");
function Ke(i) {
  const {
    className: o,
    render: c,
    defaultValue: a,
    value: g,
    onValueChange: n,
    actionsRef: v,
    delay: p,
    closeDelay: l,
    orientation: u,
    onOpenChangeComplete: t,
    ...s
  } = i.componentProps, r = Te(), {
    rootRef: w,
    nested: d
  } = x(), {
    open: m
  } = x(), h = e.useMemo(() => ({
    open: m,
    nested: d
  }), [m, d]), N = j(d ? "div" : "nav", i.componentProps, {
    state: h,
    ref: [i.forwardedRef, w],
    props: [{
      "aria-orientation": u
    }, s]
  });
  return /* @__PURE__ */ f.jsx(he.Provider, {
    value: r,
    children: N
  });
}
const G = /* @__PURE__ */ e.createContext(void 0);
process.env.NODE_ENV !== "production" && (G.displayName = "NavigationMenuPortalContext");
function Qe() {
  const i = e.useContext(G);
  if (i === void 0)
    throw new Error("Base UI: <NavigationMenu.Portal> is missing.");
  return i;
}
function Ze(i) {
  const {
    children: o,
    keepMounted: c = !1,
    container: a
  } = i, {
    mounted: g
  } = x();
  return g || c ? /* @__PURE__ */ f.jsx(G.Provider, {
    value: c,
    children: /* @__PURE__ */ f.jsx(Ae, {
      root: a,
      children: o
    })
  }) : null;
}
const $ = /* @__PURE__ */ e.createContext(void 0);
process.env.NODE_ENV !== "production" && ($.displayName = "NavigationMenuPositionerContext");
function L(i = !1) {
  const o = e.useContext($);
  if (!o && !i)
    throw new Error("Base UI: NavigationMenuPositionerContext is missing. NavigationMenuPositioner parts must be placed within <NavigationMenu.Positioner>.");
  return o;
}
const et = {
  name: "adaptiveOrigin",
  async fn(i) {
    var h, N;
    const {
      x: o,
      y: c,
      rects: {
        floating: a
      },
      elements: {
        floating: g
      },
      platform: n,
      strategy: v,
      placement: p
    } = i, l = g.ownerDocument.defaultView, u = await ((h = n.getOffsetParent) == null ? void 0 : h.call(n, g));
    let t = {
      width: 0,
      height: 0
    };
    if (v === "fixed" && (l != null && l.visualViewport))
      t = {
        width: l.visualViewport.width,
        height: l.visualViewport.height
      };
    else if (u === l) {
      const P = ue(g);
      t = {
        width: P.documentElement.clientWidth,
        height: P.documentElement.clientHeight
      };
    } else await ((N = n.isElement) == null ? void 0 : N.call(n, u)) && (t = await n.getDimensions(u));
    const s = Le(p);
    let r = o, w = c;
    return s === "left" && (r = t.width - (o + a.width)), s === "top" && (w = t.height - (c + a.height)), {
      x: r,
      y: w,
      data: {
        sideX: s === "left" ? "right" : "left",
        sideY: s === "top" ? "bottom" : "top"
      }
    };
  }
}, de = /* @__PURE__ */ e.forwardRef(function(o, c) {
  const {
    open: a,
    mounted: g,
    positionerElement: n,
    setPositionerElement: v,
    floatingRootContext: p,
    nested: l
  } = x(), {
    className: u,
    render: t,
    anchor: s,
    positionMethod: r = "absolute",
    side: w = "bottom",
    align: d = "center",
    sideOffset: m = 0,
    alignOffset: h = 0,
    collisionBoundary: N = "clipping-ancestors",
    collisionPadding: P = 5,
    collisionAvoidance: M = l ? Se : Ve,
    arrowPadding: V = 5,
    sticky: D = !1,
    trackAnchor: _ = !0,
    ...I
  } = o, k = Qe(), T = Ne(), y = _e(), [b, O] = e.useState(!1), F = e.useRef(null), A = e.useRef(null);
  e.useEffect(() => {
    if (!n)
      return;
    function R(C) {
      n && X(C) && (C.type === "focusin" ? ze : Be)(n);
    }
    return n.addEventListener("focusin", R, !0), n.addEventListener("focusout", R, !0), () => {
      n.removeEventListener("focusin", R, !0), n.removeEventListener("focusout", R, !0);
    };
  }, [n]);
  const E = ke({
    anchor: s ?? (p == null ? void 0 : p.elements.domReference) ?? A,
    positionMethod: r,
    mounted: g,
    side: w,
    sideOffset: m,
    align: d,
    alignOffset: h,
    arrowPadding: V,
    collisionBoundary: N,
    collisionPadding: P,
    sticky: D,
    trackAnchor: _,
    keepMounted: k,
    floatingRootContext: p,
    collisionAvoidance: M,
    nodeId: T,
    // Allows the menu to remain anchored without wobbling while its size
    // and position transition simultaneously when side=top or side=left.
    adaptiveOrigin: et
  }), H = e.useMemo(() => {
    const R = {};
    return a || (R.pointerEvents = "none"), {
      role: "presentation",
      hidden: !g,
      style: {
        ...E.positionerStyles,
        ...R
      }
    };
  }, [a, g, E.positionerStyles]), z = e.useMemo(() => ({
    open: a,
    side: E.side,
    align: E.align,
    anchorHidden: E.anchorHidden,
    instant: b
  }), [a, E.side, E.align, E.anchorHidden, b]);
  e.useEffect(() => {
    if (!a)
      return;
    function R() {
      He.flushSync(() => {
        O(!0);
      }), y.start(100, () => {
        O(!1);
      });
    }
    const C = ye(n);
    return C.addEventListener("resize", R), () => {
      C.removeEventListener("resize", R);
    };
  }, [a, y, n]);
  const B = j("div", o, {
    state: z,
    ref: [c, v, F],
    props: [H, I],
    customStyleHookMapping: Y
  });
  return /* @__PURE__ */ f.jsx($.Provider, {
    value: E,
    children: B
  });
});
process.env.NODE_ENV !== "production" && (de.displayName = "NavigationMenuPositioner");
function ae({
  children: i
}) {
  const {
    beforeInsideRef: o,
    beforeOutsideRef: c,
    afterInsideRef: a,
    afterOutsideRef: g,
    positionerElement: n,
    viewportElement: v,
    floatingRootContext: p
  } = x(), l = !!L(!0), u = n || v;
  return !p && !l ? i : /* @__PURE__ */ f.jsxs(e.Fragment, {
    children: [/* @__PURE__ */ f.jsx(se, {
      ref: o,
      onFocus: (t) => {
        var s, r;
        u && X(t, u) ? (s = Ue(u)) == null || s.focus() : (r = c.current) == null || r.focus();
      }
    }), i, /* @__PURE__ */ f.jsx(se, {
      ref: a,
      onFocus: (t) => {
        var s, r;
        u && X(t, u) ? (s = We(u)) == null || s.focus() : (r = g.current) == null || r.focus();
      }
    })]
  });
}
const fe = /* @__PURE__ */ e.forwardRef(function(o, c) {
  const {
    className: a,
    render: g,
    children: n,
    id: v,
    ...p
  } = o, l = qe(v), {
    setViewportElement: u,
    setViewportTargetElement: t,
    floatingRootContext: s,
    prevTriggerElementRef: r,
    viewportInert: w,
    setViewportInert: d
  } = x(), m = !!L(!0), h = s == null ? void 0 : s.elements.domReference;
  $e(() => {
    h && (r.current = h);
  }, [h, r]);
  const N = j("div", o, {
    ref: [c, u],
    props: [{
      id: l,
      onBlur(P) {
        const M = P.relatedTarget, V = P.currentTarget;
        M && !ce(V, M) && M !== h && d(!0);
      },
      ...!m && w && {
        inert: Je(!0)
      },
      children: m ? n : /* @__PURE__ */ f.jsx(ae, {
        children: /* @__PURE__ */ f.jsx("div", {
          ref: t,
          children: n
        })
      })
    }, p]
  });
  return m ? /* @__PURE__ */ f.jsx(ae, {
    children: N
  }) : N;
});
process.env.NODE_ENV !== "production" && (fe.displayName = "NavigationMenuViewport");
const tt = {
  ...Y,
  ...Xe
}, pe = /* @__PURE__ */ e.forwardRef(function(o, c) {
  const {
    className: a,
    render: g,
    id: n,
    ...v
  } = o, {
    open: p,
    transitionStatus: l,
    setPopupElement: u
  } = x(), t = L(), s = Ge(), r = Ye(n), w = e.useMemo(() => ({
    open: p,
    transitionStatus: l,
    side: t.side,
    align: t.align,
    anchorHidden: t.anchorHidden
  }), [p, l, t.side, t.align, t.anchorHidden]);
  let d = t.side === "top", m = t.side === "left";
  return s === "rtl" ? (d = d || t.side === "inline-end", m = m || t.side === "inline-end") : (d = d || t.side === "inline-start", m = m || t.side === "inline-start"), j("nav", o, {
    state: w,
    ref: [c, u],
    props: [{
      id: r,
      tabIndex: -1,
      style: d ? {
        position: "absolute",
        [t.side === "top" ? "bottom" : "top"]: "0",
        [m ? "right" : "left"]: "0"
      } : {}
    }, v],
    customStyleHookMapping: tt
  });
});
process.env.NODE_ENV !== "production" && (pe.displayName = "NavigationMenuPopup");
const me = /* @__PURE__ */ e.forwardRef(function(o, c) {
  const {
    className: a,
    render: g,
    ...n
  } = o, {
    open: v
  } = x(), {
    arrowRef: p,
    side: l,
    align: u,
    arrowUncentered: t,
    arrowStyles: s
  } = L(), r = e.useMemo(() => ({
    open: v,
    side: l,
    align: u,
    uncentered: t
  }), [v, l, u, t]);
  return j("div", o, {
    state: r,
    ref: [c, p],
    props: [{
      style: s,
      "aria-hidden": !0
    }, n],
    customStyleHookMapping: Y
  });
});
process.env.NODE_ENV !== "production" && (me.displayName = "NavigationMenuArrow");
function yt(i) {
  const { container: o, children: c, ...a } = i;
  return /* @__PURE__ */ f.jsxs(le, { className: Ee(), ...a, children: [
    c,
    /* @__PURE__ */ f.jsx(Ze, { container: o, children: /* @__PURE__ */ f.jsx(
      de,
      {
        sideOffset: 10,
        collisionPadding: { top: 5, bottom: 5, left: 40, right: 40 },
        className: we({}),
        style: {
          "--duration": "0.35s",
          "--easing": "cubic-bezier(0.22, 1, 0.36, 1)"
          // left: "0!important",
        },
        children: /* @__PURE__ */ f.jsxs(pe, { className: Me(), children: [
          /* @__PURE__ */ f.jsx(me, { className: Re(), children: /* @__PURE__ */ f.jsx(xe, {}) }),
          /* @__PURE__ */ f.jsx(
            fe,
            {
              className: Pe()
            }
          )
        ] })
      }
    ) })
  ] });
}
export {
  yt as default
};
